module.exports = __webpack_public_path__ + "img/icon_chip_07.050b1c18.png";